module.exports = __webpack_public_path__ + "img/bass-1.76aebaa6.jpg";